import { z } from "zod";
import { FORM_ERROR_MESSAGES } from "@shared/constants";
import { User } from "@shared/models";
import {
  AssignOnboardingToUserDto,
  AssignOnboardingToUserFormShape,
} from "@containers/User/interfaces/UserForm.interface";

export const validationSchema = z.object({
  onboarding_id: z.number(FORM_ERROR_MESSAGES.REQUIRED),
});

export const getInitValues = (): AssignOnboardingToUserFormShape => ({
  onboarding_id: null,
});

export const prepareSubmitValue = (values: AssignOnboardingToUserFormShape, user: User): AssignOnboardingToUserDto => {
  return {
    ...values,
    user_id: user.id,
  };
};
